export const root = '/profile';
export const editAddress = `${root}/edit/address`;
export const editEmail = `${root}/edit/email`;
export const editBankDetails = `${root}/edit/bank-details`;
